<template>
  <a-card :bordered="false">
    <div>
      <div class="operation-wrap">
        <div>
        </div>
        <a-button v-has="'ROLE_ADD'" type="primary" @click="addRole">
          {{ $t('ADD') || '添加' }}
        </a-button>
      </div>
      <a-table
        :data-source="table.data"
        row-key="id"
        style="width: 100%">
        <a-table-column
          data-index="name"
          :title="$t('NAME') || '角色'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="description"
          :title="$t('DESCRIPTION') || '描述'"
          width="180">
        </a-table-column>
        <a-table-column
          data-index="isActive"
          :title="$t('IS_ACTIVE') || '是否有效'"
          width="180">
          <template slot-scope="text,record">
            <a-tag type="success" v-if="record.isActive==='YES'">是</a-tag>
            <a-tag type="danger" v-if="record.isActive==='NO'">否</a-tag>
          </template>
        </a-table-column>
        <a-table-column
          data-index="date"
          :title="$t('OPERATION') || '操作'">
          <template slot-scope="text, record">
            <a-button type="link" @click="editRole(record.id)">{{ $t('EDIT') || '编辑' }}
            </a-button>
            <a-button type="link" v-has="'ROLE_DELETE'" @click="deleteRole(record.id)">{{ $t('DELETE') || '删除' }}
            </a-button>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      :footer="null"
      title="提示"
      @close="closeForm"
      v-model="form.visible">
      <role-edit
        v-if="form.visible"
        :role-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm">
      </role-edit>
    </a-modal>
  </a-card>
</template>

<script>
import {
  _queryRoles,
  _deleteRole,
} from '@/api/sysRoleApi';
import RoleEdit from './RoleEdit.vue';

async function getRoleList() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const { content } = await _queryRoles({
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
    date: this.table.query.date,
  });
  this.table.data = content;
}

function addRole() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editRole(roleId) {
  this.form.data.id = roleId;
  this.form.visible = true;
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.getRoleList();
}

async function deleteRole(roleId) {
  this.$confirm({
    title: '是否删除？',
    content: '',
    onOk: async () => {
      const result = await _deleteRole(roleId);
      if (result) {
        this.$message.success('删除成功');
        await this.getRoleList();
      }
    },
  });
}

export default {
  name: 'RoleList',
  components: { RoleEdit },
  data() {
    return {
      form: {
        data: {
          id: null,
        },
        visible: false,
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'createAt',
          order: 'descending',
        },
      },
    };
  },
  methods: {
    getRoleList,
    deleteRole,
    editRole,
    addRole,
    closeForm,
  },
  created() {
    this.getRoleList();
  },
};
</script>

<style scoped>

</style>
